// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

enum WorkspaceAction {
  CreateWorkspace = 'workspace-create-workspace',
  Rename = 'workspace-rename',
  MakeAvailableOffline = 'workspace-make-available-offline',
  CopyLink = 'workspace-copy-link',
  ShowDetails = 'workspace-show-details',
  Share = 'workspace-share',
  ShowHistory = 'workspace-show-history',
  OpenInExplorer = 'workspace-open-in-explorer',
  Mount = 'workspace-mount',
  UnMount = 'workspace-unmount',
  Favorite = 'workspace-favorite',
  Archive = 'workspace-archive',
  Restore = 'workspace-restore',
  Trash = 'workspace-trash',
  TakeOwnership = 'workspace-take-ownership',
}

enum WorkspaceMenu {
  All = 'all',
  Recent = 'recent',
  Favorites = 'favorites',
  Hidden = 'hidden',
}

function isWorkspaceAction(value: any): value is WorkspaceAction {
  return Object.values(WorkspaceAction).includes(value);
}

export { WorkspaceAction, WorkspaceMenu, isWorkspaceAction };
